import { Mutation } from 'vuex'
import { MediaLibraryState } from '../types'
import { MediaLibraryEssence } from '@/types/mediaLibrary'

const setPendingRequests: Mutation<MediaLibraryState> = (
  state,
  { essence, requestId }: { essence: MediaLibraryEssence; requestId: number }
) => {
  const mediaLibrary = new Map(state.value)
  const mediaLibraryItem = mediaLibrary.get(essence)

  if (mediaLibraryItem) {
    mediaLibraryItem.pendingRequests.push(requestId)

    state.value = mediaLibrary
  }
}

export default setPendingRequests
